// src/modules/components/reports/calls/StatusChip.js
import React from "react";
import { Chip } from "@mui/material";

const StatusChip = ({ record }) => {
  const getStatusProps = (status) => {
    if (!status) return { color: 'default', label: 'Unknown' };
    
    const statusLower = status.toLowerCase();
    
    switch (statusLower) {
      case 'answered':
        return { color: 'success', label: 'Answered' };
      case 'no answer':
      case 'no_answer':
        return { color: 'warning', label: 'No Answer' };
      case 'busy':
        return { color: 'error', label: 'Busy' };
      case 'failed':
        return { color: 'error', label: 'Failed' };
      default:
        return { color: 'default', label: status };
    }
  };

  const props = getStatusProps(record?.disposition);
  
  return (
    <Chip
      label={props.label}
      color={props.color}
      size="small"
      variant="outlined"
    />
  );
};

export default StatusChip;